import { useOnline } from "@jkast90/kast-common/offline";
import { here } from "../../desktop/desktop";
import { AccountControls } from "../../common/account";
import { ProfileButton } from "@jkast90/kast-common/ui";

// In both headers (the site's and the player's), so it is where being
// offline shows on every page. Signing out is on the profile page. Sign-in is a page on another origin, which
// offline would leave an app on the home screen stuck on an error page.
export function OfflineChip({ signedIn }: { signedIn: boolean }) {
  return (
    <span
      className="offline-chip"
      role="status"
      data-tip={`You're offline. Games and saves in ${here} still work${signedIn ? "; cloud saves go up when you're back online" : "; signing in needs a connection"}.`}
    >
      Offline
    </span>
  );
}

/**
 * The player's header: the profile button, with the offline chip, and no Admin
 * link. Drawn from the account kit's state (`AccountControls`' `render`), so
 * who is signed in, the profile page and CloudBoy's own sign-in (offline and
 * the desktop app) come from the kit. (The site's pages have the whole account
 * bar: TopBar.)
 */
export default function AuthMenu() {
  const online = useOnline();
  return (
    <AccountControls
      render={(c) => (
        <div className="auth">
          <ProfileButton
            signedIn={c.identity.signedIn}
            loading={c.identity.loading}
            canSignIn={online}
            name={c.identity.displayName}
            picture={c.picture}
            href={c.profileHref}
            onSignIn={c.signIn}
            className="auth-me"
          >
            {!online && <OfflineChip signedIn={c.identity.signedIn} />}
          </ProfileButton>
        </div>
      )}
    />
  );
}
